import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const HeaderBanner = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 0 20px;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  align-self: stretch;
`;

export const AccountAvatar = styled.img`
  width: 96px;
  height: 96px;
  object-fit: contain;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  padding: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
`;

export const HeaderTextBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h4`
  margin: 0;
  color: var(--black-dark);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: var(--font-family-base);
  font-size: 24px;
  font-style: normal;
  font-weight: 900;
  line-height: 32px;
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  color: var(--light-gray-darker);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: var(--font-family-base);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
